import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "../../dashboard/manage-employee/manageEmployee.css";
import { useEffect, useMemo, useState } from "react";
import { TellBossService } from "../../../_service";
import { EmployeeListProps } from "../../../_types";
import { useAppSelector } from "../../../_app";

import {
  CommonModal,
  CompanyInfoModal,
  CustomButton,
  CustomSelectField,
  Loader,
} from "../../../components";
import { SearchField, TableFilterHeader } from "../../dashboard/component";
import styled from "styled-components";
import { Notify, Utils } from "../../../utils";
import { Constant } from "../../../config";
import { DashboardService } from "../../../_service/DashboardService";
import moment from "moment";

const PAYROLL_PREVIEW_STORAGE_KEY = "payrollPreview";

const PayrollList = () => {
  const date = new Date();
  const { state } = useLocation();
  const approvalOptions = ["Yes", "No"];

  const navigate = useNavigate();
  const location = useLocation();

  const user = useAppSelector((state) => state.user);
  const [text, setText] = useState("");
  const [char, setChar] = useState("");
  const [status, setStatus] = useState("1");
  const [employeeList, setEmployeeList] = useState<EmployeeListProps[]>([]);
  const [confirmPayslip, setConfirmPayslip] = useState<boolean>(false);
  const [approvalDate, setApprovalDate] = useState<string>('');
  const [filterEmployeeList, setfilterEmployeeList] = useState<
    EmployeeListProps[]
  >([]);
  const [sending, setSending] = useState(true);
  const [pageInfo, setPageInfo] = useState<{
    pageNumber: number;
    totalLength: number;
    pagePerData: number;
  }>({
    pageNumber: 1,
    totalLength: 10,
    pagePerData: 10,
  });
  const [payrunApprovalStatuses, setPayrunApprovalStatuses] = useState<Record<string, any>>({});
  const [approvalHistory, setApprovalHistory] = useState<any>(null);
  const [cpfReturnStatus, setCpfReturnStatus] = useState<any>(null);
  const companyId = useAppSelector((state) => state.user.defaultCompnayId);
  const currentPayrunDate = useAppSelector(
    (state) => state.user.current_payrun_date
  );

  const [isFiltered, setIsFiltered] = useState(false);
  const [month, setMonth] = useState<string>(location?.state?.month ||
    `${parseInt(currentPayrunDate?.split("-")[1] || 0) || date.getMonth() + 1}`
  );
  const [employeeYear, setEmployeeYear] = useState(location?.state?.year ||
    currentPayrunDate?.split("-")[0] || date.getFullYear()
  );
  const [openReversalModal, setOpenReversalModal] = useState<boolean>(false);

  const [isAllPayrunCreated, setIsAllPayrunCreated] = useState<boolean>(false)

  const [summary, setSummary] = useState<any>({});

  const [payrunList, setPayrunList] = useState<any>([]);

  const [currentPayrun, setCurrentPayrun] = useState<any>(null);

  const [selectedPayrunId, setSelectedPayrunId] = useState<any>(location?.state?.currentPayrunId || "");

  const [payrunChangeStatuses, setPayrunChangeStatuses] = useState<Record<string, string>>({});

  const getCurrentPayrunChangeStatus = () => {
    return currentPayrun?.id ? (payrunChangeStatuses[currentPayrun.id] || "") : "";
  };

  const updatePayrunChangeStatus = (payrunId: string, status: string) => {
    setPayrunChangeStatuses(prev => ({
      ...prev,
      [payrunId]: status
    }));
  };

  const changeStatus = getCurrentPayrunChangeStatus();

  console.log("thePayrunList", payrunList, currentPayrun);

  console.log("PayrollList location state", location?.state);

  const monthsOptions = Utils.MONTH_OPTIONS;
  const yearsTillNow = Utils.getDefaultYearRange()

  const textColor = {
    new: "#155724",
    existing: "#059BBF",
    resigned: "#dc3545",
  } as any;

  const getEmployeeList = async (type: string) => {
    const defaultCompanyId = user.defaultCompnayId;
    if (type !== "0") {
      setIsFiltered(() => true);
    } else {
      setIsFiltered(() => false);
    }
    if (defaultCompanyId) {
      try {
        setSending(() => true);
        const res = await TellBossService._getPendingApprovalList(
          defaultCompanyId,
          Utils.getLastDayOfMonth(employeeYear, month)
        );
        if (res.status === 200) {

          let list = Object.values(res?.data?.data).flat().map((item: any) => {
            return {
              ...item,
              id: item?.approval_history?.id
            };
          });
          setPayrunList(() => list);
          
          if (location?.state?.currentPayrunId) {
            const selectedPayrun = list?.find((p: any) => p.id === location?.state?.currentPayrunId);
            setCurrentPayrun(() => selectedPayrun || null);
            setSelectedPayrunId(() => selectedPayrun?.id || "");
          } else {
            let index = list.length > 0 ? list.length - 1 : 0;
            setCurrentPayrun(() => list[index] || null);
            setSelectedPayrunId(() => list[index]?.id || "");
          }

          setEmployeeList(() => res?.data?.data?.payslips);
          setfilterEmployeeList(() => res?.data?.data?.payslips);
          setPageInfo((prev) => ({
            ...prev,
            totalLength: res?.data?.data?.payslips?.length,
          }));
        }
        setPayrunApprovalStatuses((prev) => ({
          ...prev,
          [res?.data?.data?.approval_history?.id]: res?.data?.data?.approval_history?.action_taken
        }));
        setApprovalDate(
          () => res?.data?.data?.approval_history?.updated_at
        );
        setApprovalHistory(() => res?.data?.data?.approval_history);
        setIsAllPayrunCreated(
          () => res?.data?.data?.summary?.is_all_pay_run
        );
        setCpfReturnStatus(
          () => res?.data?.data?.summary?.is_cpf_return_finalized
        );
        setSummary(() => res?.data?.data?.summary);
        setChar("All");
        setSending(() => false);

        const approvalStatus = res?.data?.data?.approval_history?.action_taken;
        if (approvalStatus !== null) {
          updatePayrunChangeStatus(
            res?.data?.data?.approval_history?.id,
            approvalStatus === true ? "Yes" : "No"
          );
        }
      } catch (e: any) {
        console.log(e);
        setSending(() => false);
        setEmployeeList(() => []);
        setfilterEmployeeList(() => []);
        setPageInfo((prev) => ({
          ...prev,
          totalLength: 0,
        }));
        if (e.response?.data?.payslip_date?.length) {
          Notify(e.response?.data?.payslip_date[0], 0);
        }
      }
    }
  };

  const handlePageValueChange = (
    type: "next" | "previous" | "first" | "last"
  ) => {
    if (type === "next") {
      const isLast =
        pageInfo.pageNumber * pageInfo.pagePerData < employeeList?.length || 0;
      if (isLast) {
        setPageInfo((prev) => ({ ...prev, pageNumber: prev.pageNumber + 1 }));
      }
    }
    if (type === "previous") {
      if (pageInfo.pageNumber > 1) {
        setPageInfo((prev) => ({
          ...prev,
          pageNumber: prev.pageNumber - 1,
        }));
      }
    }
    if (type === "first") {
      setPageInfo((prev) => ({
        ...prev,
        pageNumber: 1,
      }));
    }
    if (type === "last") {
      setPageInfo((prev) => ({
        ...prev,
        pageNumber: Math.ceil(pageInfo.totalLength / pageInfo.pagePerData),
      }));
    }
  };

  const sendApprovalTicket = async (
    approvalMonth: string,
    approvalYear: string
  ) => {
    const formData = new FormData();

    formData.append("company", user.defaultCompnayId);
    formData.append("request_type", "AP");
    formData.append("name", user.name);
    formData.append("email", user.email);
    formData.append(
      "message",
      `Boss has approved payroll for ${approvalMonth}, ${approvalYear}. Now, proceed to create PayRun for respective month.`
    );

    const { status } = await DashboardService._submitRequest(formData);
    return status;
  };

  const checkCPFReturnStatus = async () => {
    try {
      let res = await TellBossService._checkCPFReturnStatus(user.defaultCompnayId, Utils.getLastDayOfMonth(employeeYear, month));

      if (res.status >= 200 && res.status < 300) {
        console.log("CPF Status", res?.data?.data)
        setCpfReturnStatus(res?.data?.data?.is_cpf_return_finalized)
      }
    } catch (e: any) {
      Notify(Constant.common.something_went_wrong, 0);
    }
  }

  const reverseApproval = async () => {
    setSending(true);
    try {
      let res = await TellBossService._reverseApproval(user.defaultCompnayId, Utils.getLastDayOfMonth(employeeYear, month));

      if (res.status >= 200 && res.status < 300) {
        getEmployeeList(status).then(() => updatePayrunChangeStatus(currentPayrun.id, "Yes"));
        Notify(res.data.data.message, 1);
        setSending(false);
        setOpenReversalModal(false);

      }
    } catch (e: any) {
      Notify(Constant.common.something_went_wrong, 0);
      setSending(false);
      setOpenReversalModal(false)
    }
  }

  const approvePayslip = async () => {
    setSending(true);
    setConfirmPayslip(() => false);

    const defaultCompanyId = user.defaultCompnayId;
    try {
      const data = {
        company: defaultCompanyId,
        payslip_date: Utils.getLastDayOfMonth(employeeYear, month),
        action_taken: changeStatus === "Yes" ? "1" : "0",
        approval_history_id: currentPayrun?.approval_history?.id || null,
      };
      const res = await TellBossService._approvePayslip(data);
      if (res.status >= 200 && res.status < 300) {
        const index = monthsOptions.findIndex((data) => data.value === month);
        const requestStatus = await sendApprovalTicket(
          monthsOptions[index].key,
          employeeYear
        );

        if (requestStatus >= 201 && requestStatus < 300) {
          getEmployeeList(status);
          updatePayrunApprovalStatus(currentPayrun.id, changeStatus === "Yes" ? true : false);
          Notify(res.data.data.message, 1);
          setSending(false);
        }
      }
    } catch (e: any) {
      updatePayrunChangeStatus(currentPayrun.id, "Yes");
      Notify(Constant.common.something_went_wrong, 0);
      setSending(false);
    }
  };

  useEffect(() => {
    getEmployeeList(status);
    if (state?.change) {
      if (currentPayrun?.id) {
        updatePayrunChangeStatus(currentPayrun.id, state.change);
      }
    }
  }, [month, employeeYear, status]);

  useEffect(() => {
    if (text === "") {
      setfilterEmployeeList(employeeList);
    } else {
      setfilterEmployeeList(() => {
        return employeeList.filter((item) => {
          if (item?.user?.name?.toLowerCase().includes(text?.toLowerCase())) {
            return true;
          }
          return false;
        });
      });
    }
  }, [text]);
  // page change
  useEffect(() => {
    const startIndex =
      pageInfo.pageNumber * pageInfo.pagePerData - pageInfo.pagePerData;
    const endIndex =
      pageInfo.pageNumber * pageInfo.pagePerData > employeeList?.length
        ? employeeList.length
        : pageInfo.pageNumber * pageInfo.pagePerData;
    setfilterEmployeeList(() => employeeList?.slice(startIndex, endIndex));
  }, [pageInfo.pageNumber, employeeList]);



  const getCPFB = (item: any) => {
    let cpf_employee = Utils.getPriceFromString(item?.payslip_info?.deductions?.data?.filter((x: any) => x?.name === "CPF - Employee")[0]?.value || "0.00")
    let sdl = Utils.getPriceFromString(item?.payslip_info?.employer_contribution?.data?.filter((x: any) => x?.name === "SDL")[0]?.value || "0.00")
    let cpf_employer = Utils.getPriceFromString(item?.payslip_info?.employer_contribution?.data?.filter((x: any) => x?.name === "CPF - Employer")[0]?.value || "0.00")

    let cdac = (item?.payslip_info?.deductions?.data?.filter((x: any) => x?.name === "CDAC")[0]?.value || "0.00");
    let sinda = (item?.payslip_info?.deductions?.data?.filter((x: any) => x?.name === "SINDA")[0]?.value || "0.00");
    let ecf = (item?.payslip_info?.deductions?.data?.filter((x: any) => x?.name === "ECF")[0]?.value || "0.00");
    let mbmf = (item?.payslip_info?.deductions?.data?.filter((x: any) => x?.name === "MBMF")[0]?.value || "0.00");

    let shg = parseFloat(cdac) || parseFloat(sinda) || parseFloat(ecf) || parseFloat(mbmf) || 0.00;

    let cpfb = ((parseFloat(cpf_employee) || 0) + (parseFloat(cpf_employer) || 0) + (parseFloat(sdl) || 0) + (parseFloat(`${shg}`) || 0)).toFixed(2);

    return Utils.prependDollar(Utils.getNumberWithCommas(cpfb || 0));
  }

  console.log("isPayrunAll", isAllPayrunCreated)

  console.log("theKey", `${PAYROLL_PREVIEW_STORAGE_KEY}-${currentPayrun?.id}`)

  const employeesWithPendingChanges = useMemo(() => {
    console.log("Calculating employees with pending changes");
    const storageKey = `${PAYROLL_PREVIEW_STORAGE_KEY}-${currentPayrun?.id}`;
    return Object.keys(JSON.parse(localStorage.getItem(storageKey) || "{}"));
  }, [currentPayrun?.id]);

  let showStatusColumn = employeesWithPendingChanges?.length === 0 ? false : true;

  useEffect(() => {
    if (showStatusColumn) {
      if (currentPayrun?.id) {
        updatePayrunChangeStatus(currentPayrun.id, "Yes");
      }
    }
  }, [showStatusColumn, currentPayrun?.id])

  console.log("employeesWithPendingChanges", employeesWithPendingChanges);

  useEffect(() => {
    if (currentPayrun) {
      console.log("Current Payrun", currentPayrun);

      setEmployeeList(() => currentPayrun?.payslips);
      setfilterEmployeeList(() => currentPayrun?.payslips);
      setPageInfo((prev) => ({
        ...prev,
        totalLength: currentPayrun?.payslips?.length,
      }));

      updatePayrunApprovalStatus(currentPayrun.id, currentPayrun?.approval_history?.action_taken);
      setApprovalDate(() => currentPayrun?.approval_history?.updated_at);
      setApprovalHistory(() => currentPayrun?.approval_history);
      setIsAllPayrunCreated(() => currentPayrun?.summary?.is_all_pay_run);
      setCpfReturnStatus(() => currentPayrun?.summary?.is_cpf_return_finalized);
      setSummary(() => currentPayrun?.summary);

      const approvalStatus = currentPayrun?.approval_history?.action_taken;
      if (approvalStatus !== null && !payrunChangeStatuses[currentPayrun.id]) {
        updatePayrunChangeStatus(currentPayrun.id, approvalStatus === true ? "Yes" : "No");
      }

      setChar("All");
      setSending(false);
    }
  }, [currentPayrun]);

  const getCurrentPayrunApprovalStatus = () => {
    return currentPayrun?.id ? payrunApprovalStatuses[currentPayrun.id] : null;
  };

  const updatePayrunApprovalStatus = (payrunId: string, status: any) => {
    setPayrunApprovalStatuses(prev => ({
      ...prev,
      [payrunId]: status
    }));
  };

  const currentApprovalStatus = getCurrentPayrunApprovalStatus();

  console.log('PayrunID',payrunList, selectedPayrunId, currentPayrun?.id, currentApprovalStatus, payrunChangeStatuses);

  return (
    <div style={{ position: "relative" }}>
      {!sending &&
        employeeList &&
        employeeList?.length < 1 &&
        (char === "" || char === "All") &&
        !isFiltered ? (
        <CompanyInfoModal />
      ) : null}
      <div className="hero_header">
        <h2 className="employee-header-h2">{Utils.getTitleWithCompanyName("Payroll-TellBoss")}</h2>
      </div>
      <div>
        <div style={{
          display: "flex",
          // justifyContent: "right",
          alignItems: "center",
          width: "fit-content",
          gap: "0.5rem",
          // marginLeft: "auto",
        }}>
          <div
            style={{
              display: "flex",
              gap: 10,
              alignItems: "center",
              width: "fit-content",
            }}
          >
            {currentApprovalStatus === null && (
              <>
                <p
                  style={{
                    marginTop: 14,
                    background: "#ff6665",
                    color: "#ffffff",
                    fontWeight: 600,
                    border: "1px solid ff6665",
                    borderRadius: "0.25rem",
                    padding: ".35rem 1.25rem",
                    fontSize: "1rem",
                    whiteSpace: "nowrap",
                  }}
                >
                  Are there any changes in payslips?
                </p>
                <CustomSelectField
                  value={changeStatus}
                  onChangeOption={(value) => {
                    if (currentPayrun?.id) {
                      updatePayrunChangeStatus(currentPayrun.id, value);
                    }
                  }}
                  option={approvalOptions?.map((option) => ({
                    key: option,
                    value: option,
                  }))}
                  width="150px"
                  placeholder="Select option"
                  disabled={
                    currentApprovalStatus !== null || !filterEmployeeList?.length
                  }
                />
                {changeStatus !== "" && currentApprovalStatus === null && (
                  <PreviewButton
                    onClick={changeStatus === "Yes" ? () =>
                      navigate("/dashboard/tellboss/payroll/preview", {
                        state: {
                          payload: {
                            company: companyId,
                            payslip_date: Utils.getLastDayOfMonth(employeeYear, month),
                            action_taken: changeStatus === "Yes" ? "1" : "0",
                            approval_history_id: currentPayrun?.approval_history?.id || null,
                            month: month,
                            year: employeeYear,
                            currentPayrunId: currentPayrun?.id || null,
                          }
                        }
                      }) : () => setConfirmPayslip(() => true)
                    }
                  >
                    {changeStatus === "Yes" ? "Preview & Confirm" : "Confirm"}
                  </PreviewButton>
                )}
              </>
            )}
          </div>
        </div>

        <div>
          {currentApprovalStatus === false && (
            <div
              style={{
                display: "flex",
                // justifyContent: "right",
                alignItems: "center",
                width: "fit-content",
                gap: "0.5rem",
                marginTop: "14px",

                // marginLeft: "auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignContent: "center",
                  padding: ".35rem 1.25rem",
                  background: "#03b381",
                  color: "#ffffff",
                  fontWeight: 600,
                  borderRadius: "0.3125rem",
                }}
              >
                {/* Payroll Already Approved */}
                Pay Run Approved
              </div>

              {approvalDate && (
                <div
                  style={{
                    display: "flex",
                    alignContent: "center",
                    padding: ".35rem 1.25rem",
                    background: "#03b381",
                    color: "#ffffff",
                    fontWeight: 600,
                    borderRadius: "0.3125rem",
                    width: "fit-content",
                    marginLeft: "auto",
                  }}
                >
                  {`Received on ${moment(approvalDate).format(
                    "DD/MM/YYYY HH:mm A"
                  )}, Payroll Approval by ${approvalHistory?.approver_name || ""}`}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "1rem",
              marginTop: 10,
              width: "100%",
            }}
          >
            <div style={{ marginBottom: 5 }}>
              <CustomSelectField
                placeholder="Select Month"
                width="100%"
                margin="0rem"
                value={month}
                onChangeOption={(value: any) => setMonth(() => value)}
                option={monthsOptions.map((month: any) => ({
                  key: month.key,
                  value: month.value,
                }))}
              />
            </div>
            <div style={{ marginBottom: 0 }}>
              <CustomSelectField
                placeholder="Select Year"
                width="100%"
                margin="0rem"
                value={employeeYear}
                onChangeOption={(value: any) => setEmployeeYear(value)}
                option={yearsTillNow.map((years) => ({
                  key: years,
                  value: years,
                }))}
              />
            </div>

            <div style={{ marginBottom: 5, display: 'flex', alignItems: 'center', gap: '1rem', marginLeft: '1rem' }}>
              <label style={{ whiteSpace: 'nowrap' }}>Payruns:</label>
              <CustomSelectField
                placeholder="Select Payrun"
                width="100%"
                margin="0rem"
                value={selectedPayrunId}
                onChangeOption={(value: any) => {
                  const selectedPayrun = payrunList.find((p: any) => p.id?.toString() === value);
                  setCurrentPayrun(() => selectedPayrun || null);
                  setSelectedPayrunId(() => value);
                }}
                option={payrunList.map((payrun: any, index: number) => ({
                  key: `Payrun ${index + 1}`,
                  value: payrun.id
                }))}
              />
            </div>
          </div>

        </div>



        {/* {currentApprovalStatus === false &&
          (cpfReturnStatus || isAllPayrunCreated) && (
            <div
              style={{
                display: "flex",
                width: "100%",
                alignItems: "start",
                height: "fit-content",
              }}
            >
              <div
                style={{
                  padding: "0.5rem 0.75rem",
                  background: "#ff6665",
                  color: "#ffffff",
                  fontWeight: 600,
                  borderRadius: "0.3125rem",
                  width: "fit-content",
                  marginLeft: "auto",
                  marginBottom: "1rem",
                }}
              >
                <p>Payroll closed </p>
              </div>
            </div>
          )} */}

        <table className="company-table" style={{ margin: "1rem 0" }}>
          <thead className="company-table-head">
            <tr>
              <th
                style={{
                  width: `${100 / 10}%`,
                  textAlign: "center",
                  backgroundColor: "#FF4500",
                }}
              >
                Total Employee
              </th>
              <th
                style={{
                  width: `${100 / 10}%`,
                  textAlign: "right",
                  backgroundColor: "#FF4500",
                }}
              >
                Gross Income
              </th>
              <th
                style={{
                  width: `${100 / 10}%`,
                  textAlign: "right",
                  backgroundColor: "#FF4500",
                }}
              >
                Deductions
              </th>
              <th
                style={{
                  width: `${100 / 10}%`,
                  textAlign: "right",
                  backgroundColor: "#FF4500",
                }}
              >
                Bank to Pay
              </th>
              <th
                style={{
                  width: `${100 / 10}%`,
                  textAlign: "right",
                  backgroundColor: "#FF4500",
                }}
              >
                To Pay CPFB
              </th>
              <th
                style={{
                  width: `${100 / 10}%`,
                  textAlign: "right",
                  backgroundColor: "#FF4500",
                }}
              >
                {" "}
              </th>
              <th
                style={{
                  width: `${100 / 10}%`,
                  textAlign: "right",
                  backgroundColor: "#FF4500",
                }}
              >
                {" "}
              </th>
              <th
                style={{
                  width: `${100 / 10}%`,
                  textAlign: "right",
                  backgroundColor: "#FF4500",
                }}
              >
                {" "}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style={{
                  width: `${100 / 10}%`,
                  textAlign: "center",
                  fontSize: "1.25rem",
                  fontWeight: "bold",
                }}
              >
                {(summary?.total_employee || 0)}
              </td>
              <td
                style={{
                  width: `${100 / 10}%`,
                  textAlign: "right",
                  fontWeight: "bold",
                  fontSize: "0.875rem",
                  color: "#03B381",
                }}
              >
                {Utils.getCommanSepartedNumericStringWithDollar(summary?.gross || 0)}
              </td>
              <td
                style={{
                  width: `${100 / 10}%`,
                  textAlign: "right",
                  fontWeight: "bold",
                  fontSize: "0.875rem",
                  color: "#ff6665",
                }}
              >
                {Utils.getCommanSepartedNumericStringWithDollar(summary?.total_deduction || 0)}
              </td>
              <td
                style={{
                  width: `${100 / 10}%`,
                  textAlign: "right",
                  fontWeight: "bold",
                  fontSize: "0.875rem",
                  color: "#03B381",
                }}
              >
                {Utils.getCommanSepartedNumericStringWithDollar(summary?.net_pay || 0)}
              </td>
              <td
                style={{
                  width: `${100 / 10}%`,
                  textAlign: "right",
                  fontWeight: "bold",
                  fontSize: "0.875rem",
                  color: "#ff6665",
                }}
              >
                {Utils.getCommanSepartedNumericStringWithDollar(summary?.cpfb || 0)}
              </td>
              <td style={{ width: `${100 / 10}%`, textAlign: "right" }}>{" "}</td>
              <td style={{ width: `${100 / 10}%`, textAlign: "right" }}>{" "}</td>
              <td style={{ width: `${100 / 10}%`, textAlign: "right" }}>{" "}</td>
            </tr>
          </tbody>
        </table>

        <div className="table">
          {sending && <Loader />}
          {filterEmployeeList?.length > 0 && (
            <TableFilterHeader
              name="Employee"
              pageInfo={pageInfo}
              setPageInfo={setPageInfo}
              handlePageValueChange={(val) => handlePageValueChange(val)}
            />
          )}
          <table className="company-table">
            <thead className="company-table-head">
              <tr>
                <th style={{ width: `${100 / 10}%`, textAlign: "left" }}>
                  Employee Name
                </th>
                <th style={{ width: `${100 / 10}%`, textAlign: "right" }}>
                  Gross Income
                </th>
                <th style={{ width: `${100 / 10}%`, textAlign: "right" }}>Deductions</th>
                <th style={{ width: `${100 / 10}%`, textAlign: "right" }}>
                  Bank to Pay
                </th>
                <th style={{ width: `${100 / 10}%`, textAlign: "right" }}>
                  To Pay CPFB
                </th>
                <th style={{ width: `${100 / 10}%`, textAlign: "right" }}>
                  Employee Status
                </th>
                <th style={{ width: `${100 / 10}%`, textAlign: "right" }}>
                  Resigned Date
                </th>
                <th
                  style={{
                    width: `${100 / 10}%`,
                    textAlign: "right",
                    whiteSpace: "nowrap",
                  }}
                >
                  Payslip Status
                </th>
                {changeStatus === "Yes" && currentApprovalStatus === null && (
                  <th style={{ width: `${100 / 10}%`, textAlign: "right" }}>Action</th>
                )}

                {showStatusColumn && <th style={{ width: `${100 / 10}%`, textAlign: "right" }}>Pending Confirmation</th>}
              </tr>
            </thead>

            <tbody>
              {filterEmployeeList
                ?.sort((a, b) => a.employee.name.localeCompare(b.employee.name))
                ?.map((item: any) => {
                  return (
                    <tr key={item.id}>
                      <td
                        style={{
                          width: `${100 / 10}%`,
                          textAlign: "left",
                          fontWeight: "bold",
                        }}
                      >
                        <Span className="td-link">
                          {item?.employee?.name || ""}
                        </Span>
                      </td>
                      <td style={{ textAlign: "right", width: `${100 / 10}%` }}>
                        <Span>
                          {Utils.prependDollar(
                            Utils.getNumberWithCommas(
                              Number(
                                parseFloat(
                                  Utils.getPriceFromString(
                                    item?.payslip_info?.income?.total || "0.00"
                                  )
                                ) +
                                parseFloat(
                                  Utils.getPriceFromString(
                                    item?.payslip_info?.allowance?.total ||
                                    "0.00"
                                  )
                                )
                              ).toFixed(2)
                            )
                          )}
                        </Span>
                      </td>
                      <td style={{ textAlign: "right", width: `${100 / 10}%` }}>
                        <Span>
                          {Utils.prependDollar(
                            item?.payslip_info?.deductions?.total || "0.00"
                          )}
                        </Span>
                      </td>
                      <td style={{ textAlign: "right", width: `${100 / 10}%` }}>
                        <Span>
                          {Utils.prependDollar(
                            item?.payslip_info?.net_pay || "0.00"
                          )}
                        </Span>
                      </td>
                      <td style={{ textAlign: "right", width: `${100 / 10}%` }}>
                        <Span>{getCPFB(item)}</Span>
                      </td>
                      <td style={{ textAlign: "right", width: `${100 / 10}%` }}>
                        <Span
                          style={{
                            color:
                              textColor[item?.employment_status?.toLowerCase()],
                          }}
                        >
                          {item?.employment_status || ""}
                        </Span>
                      </td>
                      <td style={{ textAlign: "right", width: `${100 / 10}%` }}>
                        <Span>
                          {item?.eos !== null
                            ? Utils._dateToShow(item?.eos?.last_date_of_service)
                            : ""}
                        </Span>
                      </td>
                      <td style={{ textAlign: "right", width: `${100 / 10}%` }}>
                        <Span
                          style={{
                            color: item?.is_finalized ? "#28a745" : "#dc3545",
                          }}
                        >
                          {item?.is_approved ? "Approved" : item?.is_finalized ? "Finalised" : "Unfinalised"}

                        </Span>
                      </td>
                      {changeStatus === "Yes" && currentApprovalStatus === null && (
                        <td style={{ textAlign: "right", width: `${100 / 10}%` }}>
                          <NavLink to="change" state={{ payrollItem: item, employeesWithPendingChanges: employeesWithPendingChanges, empId: item?.employee?.id, hasPendingChanges: employeesWithPendingChanges?.includes(`${item?.employee?.id}`), month: month, year: employeeYear, currentPayrunId: currentPayrun?.id }} >
                            Change
                          </NavLink>
                        </td>
                      )}

                      {showStatusColumn && <td style={{ width: `${100 / 10}%`, fontWeight: 700, textAlign: "center", color: employeesWithPendingChanges?.includes(`${item?.employee?.id}`) ? "#28a745" : "#ff6665" }}>{employeesWithPendingChanges?.includes(`${item?.employee?.id}`) ? " Yes " : "  "}</td>}
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <div style={{ textAlign: "center", padding: ".5rem" }}>
            {!filterEmployeeList?.length && (
              <>
                <p style={{ color: "#495057" }}>No records found.</p>
                <p style={{ color: "#495057", marginTop: 10, fontWeight: 600 }}>
                  Q1. Have you completed{" "}
                  {Utils.MONTH_FULL_NAMES[parseInt(month) - 1]} {employeeYear}{" "}
                  payroll?
                </p>
                <p style={{ color: "#495057" }}>
                  A1. If "NO", go to "Manage Employees" and finalize all
                  payslips.
                </p>
                <p style={{ color: "#495057" }}>
                  A2. If "YES", go to "Pay Runs" and "Send payroll to Tellboss
                  app for boss approval of payroll"
                </p>
              </>
            )}
          </div>

          <CommonModal
            handleClose={() => setConfirmPayslip(() => false)}
            open={confirmPayslip}
            updateData={() => {
              approvePayslip();
            }}
            body={
              changeStatus === "Yes"
                ? `Are you sure you want to unapprove payroll data and send it for change?`
                : `Have Admin received Approval from TellBoss app?`
            }
            heading={
              changeStatus === "Yes"
                ? "Change Payroll"
                : "PayRun to be approved by Admin"
            }
            conformButtonText={
              changeStatus === "Yes" ? "Confirm" : "No-Admin Approves Now"
            }
            cancelButtonText={
              changeStatus === "Yes" ? "Cancel" : "Yes-Stop No action"
            }
          />

          <CommonModal
            handleClose={() => setOpenReversalModal(() => false)}
            open={openReversalModal}
            updateData={() => {
              reverseApproval();
            }}
            body={`Any changes after Approved payroll?`}
            heading={`Any changes after Approved payroll?`}
            conformButtonText="Yes - proceed to make new Changes"
            cancelButtonText="No - Stop this action"
          />
        </div>
      </div>
    </div>
  );
};

export default PayrollList;

const Span = styled.span`
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
`;

const PreviewButton = styled.p`
  padding: 0.35rem 1rem;
  color: #059bbf;
  background: #fff;
  border: 1px solid #059bbf;
  border-radius: 0.25rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: transform 0.2s ease;
  margin-top: 0.625rem;
  &:hover {
    background-color: #059bbf;
    color: #fff;
  }
`